import { ConfiguredCarFeatureFragment } from '~/graphql/__generated__/graphql';

// Sort items by ascending price, when price is similar sort alphabetically
export function sortByPriceAndName(a: ConfiguredCarFeatureFragment, b: ConfiguredCarFeatureFragment) {
	const priceA = a.price?.value || 0;
	const priceB = b.price?.value || 0;

	if (priceA !== priceB) {
		return priceA - priceB;
	}

	if (!a.name || !b.name) {
		return 0;
	}

	return a.name.localeCompare(b.name);
}
